/*
 * @Author: Zhouqi
 * @Date: 2025-10-31 14:28:39
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09
 */
import { withLayout } from '@/utils/withLayout';

import Home from '../../3.0/home/entry';

const HomePage: React.FC = () => {
  return <Home />;
};

export default withLayout(HomePage);
